var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0075c9",
    fillRule: "nonzero",
    d: "m508.1 231.2-298.6.4c-2 7.9-3 16-3 24.1 0 8.1 1 16.2 2.8 23.9h149.6v.2c-13.5 57-70.6 92.2-127.6 78.8-38.6-8.9-69.1-39.4-78.4-78.6v-.2c-3.8-15.8-3.8-32.5 0-48.3l.2-.4c13.7-56.8 70.6-91.8 127.6-78.4 19.8 4.7 37.8 15 51.8 29.9h59.6c-40.4-75.2-133.8-103.3-209-63.1-42.5 22.8-71.8 64.1-79.5 111.6v.4H52.8v-.4c2-16.6 6.1-32.8 12.3-48.5C105.2 77.3 223.5 24.5 329 64.6c54.2 20.8 97.2 63.7 117.9 118.1h51.4c-40.6-134-181.8-209.5-315.8-169-80.9 24.5-144.4 88.1-169 169-4.7 15.8-8.1 32.1-9.7 48.5-.8 8.1-1.2 16.4-1.2 24.7s.4 16 1.2 23.9h99.7v.2c13.3 84.1 92.4 141.7 176.5 128.2 66.1-10.5 117.9-62.3 128.2-128.2v-.2h50.9v.2c-2 16.6-5.9 32.8-11.9 48.3C407.6 434.1 289.6 487.5 184 447.5c-55-20.8-98.3-64.1-119.1-119.1H13.4C44.7 432.9 141.6 509.2 256 509.2s211.3-76.4 242.6-180.7c4.7-15.8 7.9-32.1 9.5-48.5.8-7.9 1.2-16 1.2-23.9 0-7.8-.4-16.8-1.2-24.9Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81146650f6d72ae2d55563df5e5d9994.svg";
export { ForwardRef as ReactComponent };